import classNames from 'classnames';
import { Icon } from 'Components';
import { NavItemConfig } from '../Siderbar.constant';
import { InfoTooltip } from 'Pages/Dashboard/components';
import styles from '../Sidebar.module.scss';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

type Props = {
	item: NavItemConfig;
	isActive: boolean;
	isOpen: boolean;
	showToolTip?: boolean;
	hasChildren: boolean;
	onClick: () => void;
	loading?: boolean;
	itemId?: string;
	disableOptions?: boolean
}

const NavItem = ({ item, isActive, isOpen, hasChildren, onClick, showToolTip = false, loading = false, itemId = "", disableOptions = false } : Props) => {
	const { t } = useTranslation();
	const openItem = hasChildren ? isOpen : false;
	const menuId = item.children?.length ? item.label.split(".")?.[1] || item?.id : itemId || item?.id || null;
	
	return <div {...(menuId ? { id: menuId } : {})} className={classNames(styles.navItem, 'menu-item', item.key === "logout" ? "sign-out" : "", { [styles['navItem--active']]: isActive, [styles['menu-item-open']]: openItem }, { [styles['navItem--disabled']]: (!item.children && disableOptions && !item.allowClick) })} onClick={onClick}>
		<InfoTooltip className={styles.item_tooltip} title={t(item.label)} enabled={showToolTip}>
			{(loading && showToolTip) ? <Spin className={styles.navItem__loading} /> : <span className={classNames(styles.navItem__icon, { [styles['navItem__label-color']]: openItem })}>
				{item.icon}
			</span>}
		</InfoTooltip>
		<span className={classNames(styles.navItem__label, { [styles['navItem__label-color']]: openItem })}>
			{t(item.label)}
		</span>
		{hasChildren && ((loading && !showToolTip) ? <Spin className={styles.navItem__loading} /> : <Icon type="chevronDown" role="icon" className={classNames(styles.navItem__chevron, { [styles['navItem__chevron--open']]: openItem })} />)}
	</div>
};

export default NavItem;